var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgProfile = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  viewBox: "0 0 30 30",
  fill: "none",
  ref: svgRef
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.42134 9.56215C8.42134 6.30621 11.1718 3.66675 14.5647 3.66675C17.9577 3.66675 20.7081 6.30621 20.7081 9.56215C20.7081 11.6066 19.6237 13.4079 17.9767 14.4654C21.6729 15.7923 24.3043 19.2123 24.3043 23.2222V25.6667H4.8252V23.2222C4.8252 19.2123 7.45662 15.7923 11.1527 14.4654C9.50577 13.4079 8.42134 11.6066 8.42134 9.56215ZM14.565 12.8693C16.4684 12.8693 18.0113 11.3887 18.0113 9.56215C18.0113 7.73565 16.4684 6.25498 14.565 6.25498C12.6617 6.25498 11.1187 7.73565 11.1187 9.56215C11.1187 11.3887 12.6617 12.8693 14.565 12.8693ZM14.565 16.4641C10.7257 16.4641 7.6039 19.4124 7.52416 23.0784H21.6059C21.5262 19.4124 18.4044 16.4641 14.565 16.4641Z",
  fill: "#11B048"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProfile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/profile.866661cc.svg";
export { ForwardRef as ReactComponent };